import { useEffect, useState } from 'react';
import { dealwithTimelineList } from '../utils';
import { getGameStoreTimelineInfo } from '@/pages/opinion/services';

const defaultTimelineData = {
  'google play': [],
  'app store': [],
  taptap: [],
};

export default function useGetStoreTimeline({
  keepParams,
  splitRegion = true,
  channel = ['app store', 'google play', 'taptap'],
}: {
  keepParams: any;
  splitRegion?: boolean;
  channel?: Array<'app store' | 'google play' | 'taptap'>;
}) {
  const [userScoreTrendsLoading, setUserScoreTrendsLoading] = useState(false);
  const [userScoreTrendsApiError, setUserScoreTrendsApiError] = useState(false);
  const [allScoreTrendsTimeline, setAllScoreTrendsTimeline] = useState({});
  const [globalTrendsTimeline, setGlobalTrendsTimeline] = useState(
    JSON.parse(JSON.stringify(defaultTimelineData)),
  );
  const requestScoreTrends = () => {
    setUserScoreTrendsLoading(true);
    setUserScoreTrendsApiError(false);
    getGameStoreTimelineInfo({
      ...keepParams,
      channel: channel,
      need_region: splitRegion,
      types: ['lifetime', 'selected'],
    })
      .then((data: any) => {
        let globalTrendsTimeline = JSON.parse(
          JSON.stringify(defaultTimelineData),
        );
        let { date_type } = keepParams;
        let { timeline_list, timeline_of_end_time, timeline_of_start_time } =
          data || {};
        let globalTimelineMap: any = {
          'google play': { selected: [], lifetime: [] },
          'app store': { selected: [], lifetime: [] },
          taptap: { selected: [], lifetime: [] },
        };

        let info: any = {};
        timeline_list?.map(({ type, list }: any) => {
          list
            ?.filter((item: { region: string }) => item.region !== 'global')
            ?.forEach((item: { region: any; channel: any }) => {
              if (item.region === '') {
                let newKey = item.channel;
                globalTimelineMap[newKey]?.[type]?.push(item);
              }

              if (splitRegion) {
                let { region, channel } = item;
                let key = channel + '-' + type;
                let regionKey = region === '' ? 'global' : region;
                if (!info[regionKey]) {
                  info[regionKey] = {
                    regionKey,
                    timeline_of_start_time,
                    timeline_of_end_time,
                  };
                }

                if (!info[regionKey][key]) {
                  info[regionKey][key] = [];
                }
                info[regionKey][key].push(item);
              }
            });
        });

        for (const key in globalTimelineMap) {
          const { selected, lifetime } = globalTimelineMap[key] || {
            selected: [],
            lifetime: [],
          };
          globalTrendsTimeline[key] = dealwithTimelineList(
            [
              { type: 'selected', list: selected },
              { type: 'lifetime', list: lifetime },
            ],
            timeline_of_start_time,
            timeline_of_end_time,
            date_type,
          );
        }
        setAllScoreTrendsTimeline(info);
        setGlobalTrendsTimeline(globalTrendsTimeline);
      })
      .finally(() => setUserScoreTrendsLoading(false));
  };

  useEffect(() => {
    if (keepParams && keepParams.entity_type === 'mobile') {
      requestScoreTrends();
    }
  }, [keepParams, channel]);

  return {
    globalTrendsTimeline,
    userScoreTrendsLoading,
    userScoreTrendsApiError,
    allScoreTrendsTimeline,
  };
}
